import React from 'react';
import { Languages } from 'lucide-react';
import { Switch } from './ui/switch';

/**
 * InterlinearOverlayHint — pill-shaped Switch + status hint shown in the
 * Bible reader chapter title row. When the toggle is ON we tell the user
 * how many verses in the current chapter have Strong's tags available.
 */
const InterlinearOverlayHint = ({
  interlinearOn,
  onToggle,
  loading,
  taggedCount,
  selectedTranslation,
  language,
  strongsSource = "KJV+Strong's",
}) => {
  return (
    <div className="mt-3 flex flex-col items-center justify-center gap-1">
      <label
        className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-purple-300/50 dark:border-purple-700/50 bg-purple-50/60 dark:bg-purple-900/20 text-xs font-medium text-purple-800 dark:text-purple-200 cursor-pointer select-none"
        data-testid="interlinear-toggle-label"
      >
        <Languages className="w-3.5 h-3.5" />
        <span>{language === 'es' ? 'Interlineal Strong' : "Strong's Interlinear"}</span>
        <Switch
          checked={interlinearOn}
          onCheckedChange={onToggle}
          data-testid="interlinear-toggle"
        />
        {loading && (
          <span className="text-[10px] text-purple-500 animate-pulse">
            {language === 'es' ? 'cargando…' : 'loading…'}
          </span>
        )}
      </label>

      {interlinearOn && !loading && taggedCount > 0 && (
        <p className="text-[10px] text-muted-foreground" data-testid="interlinear-overlay-info">
          {language === 'es'
            ? `Mostrando ${taggedCount} versículo(s) con etiquetas Strong (${strongsSource}). Los demás se muestran en ${selectedTranslation}.`
            : `Showing ${taggedCount} verse(s) with Strong's tags from ${strongsSource}. Other verses use ${selectedTranslation}.`}
        </p>
      )}
      {interlinearOn && !loading && taggedCount === 0 && (
        <p className="text-[10px] text-muted-foreground">
          {language === 'es'
            ? 'No hay versículos etiquetados con Strong en este capítulo.'
            : "No Strong's-tagged verses available for this chapter."}
        </p>
      )}
    </div>
  );
};

export default InterlinearOverlayHint;
